import { Box } from '@mui/material';
import Table from '../../../core-components/theme/components/Table/Table';
import { columns } from '../helper/tableHelper';
import { useLogbookTemplateTable } from '../hooks/useLogbookTemplateTable';

export default function LogbookTemplateTable({ searchString, isPending }: any) {
    const { logbookTemplates, lastElementRef, tableContainerRef, queryKey } = useLogbookTemplateTable(searchString);
    return (
        <Box ref={tableContainerRef} sx={{ display: 'flex', flexDirection: 'column', height: '100%', }}>
            <Table
                stickyHeader
                rows={logbookTemplates}
                columns={columns(queryKey) as any}
                lastRowRef={lastElementRef as any}
            />
        </Box>
    );
}